module.exports = __webpack_public_path__ + "img/Search_by_image.cf2c339f.svg";